import { render, staticRenderFns } from "./CategoryManager.vue?vue&type=template&id=0fa6a0bf&scoped=true"
import script from "./CategoryManager.vue?vue&type=script&lang=js"
export * from "./CategoryManager.vue?vue&type=script&lang=js"
import style0 from "./CategoryManager.vue?vue&type=style&index=0&id=0fa6a0bf&prod&lang=scss"
import style1 from "./CategoryManager.vue?vue&type=style&index=1&id=0fa6a0bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa6a0bf",
  null
  
)

export default component.exports